import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { extractPureTextFromRichText, Typography } from 'seagull';
import { normalizeDescription } from 'seagull/utils/richText';
import ServiceDescription from '~/components/ServiceBuilder/ServiceDescription/ServiceDescription';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
const ServiceDescriptionCellContent = (param)=>{
    let { service, draft, setDraft } = param;
    const form = useForm({
        mode: 'all',
        defaultValues: {
            description: service.description
        }
    });
    const onChange = (description)=>{
        setDraft(draft.setService(service.id, (s)=>_object_spread_props(_object_spread({}, s), {
                description: normalizeDescription(description)
            })));
    };
    return /*#__PURE__*/ _jsx(FormProvider, _object_spread_props(_object_spread({}, form), {
        children: /*#__PURE__*/ _jsx(ServiceDescription, {
            testId: "edit-service-description-modal",
            hideLabel: true,
            onChange: onChange
        })
    }));
};
export default function ServiceDescriptionCell(param) {
    let { index, draft, service, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.editTable.serviceCells');
    const onClick = ()=>{
        onOpenModal({
            shouldSubmit: async (draft)=>{
                var _draft_services_find, _serviceBundles_services_find;
                const serviceDescription = (_draft_services_find = draft.services().find((s)=>s.id === service.id)) === null || _draft_services_find === void 0 ? void 0 : _draft_services_find.description;
                const serviceBundles = draft.serviceBundles().find((b)=>b.services.find((s)=>s.id === service.id));
                const serviceBundlesDescription = serviceBundles === null || serviceBundles === void 0 ? void 0 : (_serviceBundles_services_find = serviceBundles.services.find((s)=>s.id === service.id)) === null || _serviceBundles_services_find === void 0 ? void 0 : _serviceBundles_services_find.description;
                return Promise.resolve(!!serviceDescription && serviceDescription !== service.description || !!serviceBundlesDescription && serviceBundlesDescription !== service.description);
            },
            renderContent: (param)=>{
                let { setDraft } = param;
                return {
                    title: t.serviceDescription(),
                    testId: "edit-service-description-modal",
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(ServiceDescriptionCellContent, {
                        service: service,
                        draft: draft,
                        setDraft: setDraft
                    })
                };
            }
        });
    };
    const pureText = useMemo(()=>extractPureTextFromRichText(service.description), [
        service.description
    ]);
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-service-description-".concat(index, "-").concat(draft.id()),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: "service-description-".concat(index, "-").concat(draft.id()),
            ellipsis: true,
            children: pureText
        })
    });
}
